/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable prettier/prettier */
/* eslint-disable unicorn/no-array-for-each */
import Modal from '../../components/Modal';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Request, { ApiMode } from '../../utils/request';
import dataLayer from '../../utils/data-layer';

const EVENT_KEY = `.lta.pd.activatewtn`;
const EVENT_CLICK_SHOW_MODAL = `click.show${EVENT_KEY}`;

class PlayerDashboardActivateWTNSection {
	init() {
		this.state = {
			section: 0,
			data: {}
		};
		this._sections = [];
		this._errorWrapper = undefined;

		this.activateWTNBtn = SelectorEngine.findOne('.js-activate-wtn');
		this._modal = SelectorEngine.findOne('#activate-wtn-modal');
		this.activateWTNBtnByUrl = SelectorEngine.findOne('.show-activate-wtn-popup');
		if ((this.activateWTNBtn && this._modal) || this.activateWTNBtnByUrl) {
			this.initActivateWTN();
		}
	}

	initActivateWTN() {
		// TODO: update all onbaording classnames here and in members-home-player-dashboard/index.njk
		// will need to update section.njk too
		const closeCtas = SelectorEngine.find('.js-onboarding-close', this._modal);
		const previousCtas = SelectorEngine.find('.js-onboarding-back', this._modal);
		const nextSectionCtas = SelectorEngine.find('.js-next-section', this._modal);
		const forms = SelectorEngine.find('.lta-content--form-element', this._modal);
		const submitAllCta = SelectorEngine.findOne('.js-activate-wtn-submit', this._modal);
		const finishCta = SelectorEngine.findOne('.js-activate-wtn-finish', this._modal);
		this._errorWrapper = SelectorEngine.findOne('.js-activate-wtn-error', this._modal);
		const closeErrorCta = SelectorEngine.findOne('.js-dismiss-submit-error', this._errorWrapper);

		this._sections = SelectorEngine.find('.lta-onboarding-container', this._modal);

		this._mainModal = new Modal(this._modal, {});

		if(this.activateWTNBtnByUrl) {
			this._mainModal.show();
		}

		closeCtas.forEach((cta) => {
			cta.addEventListener('click', () => {
				this._mainModal.hide();
			});
		});

		nextSectionCtas.forEach((cta) => {
			cta.addEventListener('click', () => {
				this.goToNextSection_();
			});
		});

		previousCtas.forEach((cta) => {
			cta.addEventListener('click', () => {
				this.goToPreviousSection_();
			});
		});

		forms.forEach((form) => {
			form.addEventListener('change', (event) => {
				this.checkForm_(event);
			});
		});

		submitAllCta.addEventListener('click', () => this.submitAllData_());

		finishCta.addEventListener('click', () => location.reload());

		closeErrorCta.addEventListener('click', () => {
			this._errorWrapper.classList.add('u-hidden');
		});

		EventHandler.on(this.activateWTNBtn, EVENT_CLICK_SHOW_MODAL, () => {
			this._mainModal.show();
		});
	}

	goToNextSection_() {
		const currentPosition = this.state.section;
		if (currentPosition + 1 < this._sections.length) {
			this._sections[currentPosition].classList.add('u-hidden');
			this._sections[currentPosition + 1].classList.remove('u-hidden');
			this.state.section = this.state.section + 1;
		}
	}

	goToPreviousSection_() {
		const currentPosition = this.state.section;
		if (currentPosition - 1 >= 0) {
			this._sections[currentPosition].classList.add('u-hidden');
			this._sections[currentPosition - 1].classList.remove('u-hidden');
			this.state.section = this.state.section - 1;
		}
	}

	checkForm_(event) {
		const { target: inputChanged, detail } = event;
		const formattedValue = inputChanged.value;
		const valueName = inputChanged.name;

		this.state.data = Object.assign({}, this.state.data, { [valueName]: formattedValue });

		const part = inputChanged.closest('.js-lta-section-content');
		const submitCta = part.querySelector('.lta-onboarding--part');

		if (submitCta !== null) {
			if (detail && detail.values.length === 0) {
				submitCta.classList.add('u-hidden');
			} else {
				submitCta.classList.remove('u-hidden');
			}
		}
	}

	async submitAllData_() {
		const url = '/api/wtn/activate/';
		const ListQuestionAnswerArray = [];
		const type = this.activateWTNBtn.getAttribute('data-wtn') || ' ';

		let counter = 1;
		for (const value of Object.values(this.state.data)) {
			ListQuestionAnswerArray.push({
				'Question': `${counter}`,
				'Answer': `${value}`
			});

			counter++;
		}
		dataLayer.push({event: 'WTN-validation', ListQuestionAnswerArray}); //pushing the selected options to datalayer with an event WTN-validation
		localStorage.setItem('WTN-validation', JSON.stringify(ListQuestionAnswerArray)); //pushing the selected options to Local storage as per Verkeer.co requested with an key WTN-validation.
		// This 'ListQuestoinAnswer' MUST be mispelled to match with the API
		const finalData = {'ListQuestoinAnswer': ListQuestionAnswerArray, type: type}

		const sumbissionResponse = await Request.post(url, finalData, { apiMode: ApiMode.Atos }).catch((error) => {
			if (error?.error?.ErrorCode == '0') {
				console.log(error);
				this.goToNextSection_();
			}else {
				console.log(error);
				this._errorWrapper.classList.remove('u-hidden');
			}
		});

		if (sumbissionResponse) {
			this.goToNextSection_();
		}
	}
}

export default PlayerDashboardActivateWTNSection;
